<template>
  <div>
    <!-- 任务内容配置 -->
    <baseBreadcrumb :page="$t('message.taskContentConfiguration')" :menu="$t('message.spotCheck')" />
    <div class="body">
      <div class="search">
        <div class="left">
          <!--任务类型  -->
          <div class="item"> <el-select v-model="datas.type" :placeholder="$t('message.taskType')" clearable filterable>
              <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select></div>
          <!-- 具体要求 -->
          <div class="item">
            <el-input v-model="datas.desc" :placeholder="$t('message.specificRequirements')" clearable></el-input>
          </div>
          <div class="item">
            <!-- 搜索 -->
            <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
            <el-button @click="reset">{{ $t('message.reset') }}</el-button>
          </div>
        </div>
        <div class="right">
          <!-- 任务类型预览 -->
          <el-button type="primary" @click="dialogVisible = true">{{ $t('message.taskTypePreview') }}</el-button>
          <!-- 创建具体要求 -->
          <el-button type="success" @click="createSpecificRequirements">{{ $t('message.createSpecificRequirements')
          }}</el-button>
        </div>
      </div>
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 任务类型 -->
          <li>{{ $t('message.taskType') }}</li>
          <!-- 具体要求 -->
          <li>{{ $t('message.specificRequirements') }}</li>
          <!-- 具体要求参考标准 -->
          <li class="flex15">{{ $t('message.specificRequirementsReferenceStandard') }}</li>
          <!-- 最后一次修改时间 -->
          <li>{{ $t('message.lastModifiedTime') }}</li>
          <!-- 备注 -->
          <li>{{ $t('message.remark') }}</li>
          <!-- 操作 -->
          <li class="flex05">{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 任务类型 -->
          <li>{{ item.type_name }}</li>
          <!-- 具体要求 -->
          <li>{{ item.desc }}</li>
          <!-- 具体要求参考标准 -->
          <li class="flex15">
            <div class="tamplate">
              <div v-html="item.content">
              </div>
            </div>
          </li>
          <!-- 最后一次修改时间 -->
          <li>{{ item.updated_at }}</li>
          <!-- 备注 -->
          <li>{{ item.remark }}</li>
          <!-- 操作 -->
          <li class="flex05">
            <el-button type="primary" @click="expectDelete(item.id)">{{ $t('message.delete') }}</el-button>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 任务类型预览 -->
    <el-dialog :title="$t('message.taskTypePreview')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="416px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!-- NO -->
            <li class="flex05">
              NO
            </li>
            <!-- 类型名称 -->
            <li class="flex15">
              {{ $t("message.typeName") }}
            </li>
          </ol>
          <ul v-for="(item, index) in options" :key="index">
            <!-- NO -->
            <li class="flex05">
              {{ index + 1 }}
            </li>
            <!-- 类型名称 -->
            <li class="flex15">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
    <!--创建具体要求  -->
    <createSpecificRequirements ref="createSpecificRequirements" :options="options" />
  </div>
</template>
<script>
import createSpecificRequirements from './components/createSpecificRequirements'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    createSpecificRequirements
  },
  data() {
    return {
      options: [],
      datas: {
        type: '',
        desc: '',
        page: 1,
        pageSize: 20,
      },
      total: 0,
      tableData: [],
      dialogVisible: false,
    };
  },
  created() {
    this.$api.spotCheckApi.spotTypeList().then(res => {
      this.options = res.data
    })
    this.expectList()
  },
  methods: {
    expectList() {
      this.$api.spotCheckApi.expectList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.expectList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 20,
        type: "",
        desc: "",

      };
      this.expectList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.expectList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.expectList();
    },
    // 创建具体要求
    createSpecificRequirements() {
      this.$refs.createSpecificRequirements.ruleForm = {}
      this.$refs.createSpecificRequirements.dialogVisible = true
    },
    //删除
    expectDelete(id) {
      this.$confirm(
        // 是否确认删除
        '是否删除该内容，删除后将无法查询，请确认！',
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: '立即删除',
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.spotCheckApi.expectDelete({ id }).then(res => {
            this.$message.success(res.msg)
            this.expectList()
          })
        })
        .catch(() => { });
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  justify-content: space-between;

  .left {
    display: flex;

    .item {
      margin-right: 20px;
    }
  }
}

.table {
  margin-top: 24px;

  ol {
    height: 50px;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  ul {
    padding: 20px 0px;
    background-color: #fff;

    li {
      word-break: break-all;
    }

    .tamplate {
      width: 100%;
      text-align: left;
    }
  }
}
</style>